import { render, staticRenderFns } from "./MoveNextYearConfirm.vue?vue&type=template&id=6dadd573"
import script from "./MoveNextYearConfirm.vue?vue&type=script&lang=js"
export * from "./MoveNextYearConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports